import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { setUser } from '../userSlice'; // import your Redux action to update token

// Simple function to check if JWT token is expired
const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch (err) {
    return true;
  }
};

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let token = api.getState().user?.token;
  console.log(token, "token");

  if (!token) {
    try {
      const root = JSON.parse(localStorage.getItem("persist:root"));
      if (root?.user) {
        const userObj = JSON.parse(root.user);
        token = userObj.token;
      }
    } catch (err) {
      console.error("Error parsing persist:root", err);
    }
  }

  // if this request requires auth, attach Authorization header
  if (args._auth) {
    if (!token) {
      console.warn("No token found in Redux Persist");
      return { error: { status: 401, data: "Unauthorized" } };
    }
    if (!args.headers) args.headers = {};
    args.headers.Authorization = `Bearer ${token}`;
  }

  const result = await baseQuery(args, api, extraOptions);

  // ⚠️ don’t remove token from localStorage here anymore,
  // since we’re relying on Redux Persist instead
  if (result.error && result.error.status === 401) {
    console.log("Unauthorized after request — redirecting to login");
    localStorage.removeItem("authtoken");
    localStorage.removeItem("refresh");
    // window.location.href = "/login"; // ⬅️ redirect
  }

  return result;
};


export const ContactsApi = createApi({
  reducerPath: 'ContactsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Contacts'],

  endpoints: (builder) => ({

    createMedicalContact: builder.mutation({
      query: (formData) => ({
        url: "/contacts/medical-info",
        method: "POST",
        body: formData, 
      }),
      invalidatesTags: ["Contacts"],
    }),
    createVisaContact: builder.mutation({
      query: (formData) => ({
        url: "/contacts/visa-info",
        method: "POST",
        body: formData, 
      }),
      invalidatesTags: ["Contacts"],
    }),
    createDentalContact: builder.mutation({
      query: (formData) => ({
        url: "/contacts/dental-info",
        method: "POST",
        body: formData, // must be FormData
      }),
      invalidatesTags: ["Contacts"],
    }),
    getAllMedicalInfo: builder.query({
      query: ({ page = 1, page_size = 10, ...filters }) => {
        const params = new URLSearchParams({ page, page_size, ...filters }).toString();
        return `/contacts/medical-info?${params}`;
      },
      providesTags: ['Contacts'],
    }),
    getMedicalbyId: builder.query({ query: (id) => `/contacts/medical-info/${id}` }),
    deleteMedical: builder.mutation({
      query: (id) => ({ url: `/contacts/medical-info/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Contacts'],
    }),
     getAllVisaInfo: builder.query({
      query: ({ page = 1, page_size = 10, ...filters }) => {
        const params = new URLSearchParams({ page, page_size, ...filters }).toString();
        return `/contacts/visa-info?${params}`;
      },
      providesTags: ['Contacts'],
    }),
      getVisalbyId: builder.query({ query: (id) => `/contacts/visa-info/${id}` }),
    deleteVisa: builder.mutation({
      query: (id) => ({ url: `/contacts/visa-info/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Contacts'],
    }),
     getAllDentalInfo: builder.query({
      query: ({ page = 1, page_size = 10, ...filters }) => {
        const params = new URLSearchParams({ page, page_size, ...filters }).toString();
        return `/contacts/dental-info?${params}`;
      },
      providesTags: ['Contacts'],
    }),
      getDentalbyId: builder.query({ query: (id) => `/contacts/dental-info/${id}` }),
    deleteDental: builder.mutation({
      query: (id) => ({ url: `/contacts/dental-info/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Contacts'],
    }),


  }),
});

export const {
  useGetDentalbyIdQuery,
  useDeleteDentalMutation,
  useGetAllDentalInfoQuery,
  useDeleteVisaMutation,
  useGetVisalbyIdQuery,
  useGetAllVisaInfoQuery,
  useDeleteMedicalMutation,
  useGetMedicalbyIdQuery,
  useGetAllMedicalInfoQuery,
  useCreateDentalContactMutation,
  useCreateVisaContactMutation,
  useCreateMedicalContactMutation,


} = ContactsApi;
